import { render, staticRenderFns } from "./edit-communicate-data.vue?vue&type=template&id=1c11aaed"
import script from "./edit-communicate-data.vue?vue&type=script&lang=ts"
export * from "./edit-communicate-data.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports